/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'fm-side-panel-small',
  templateUrl: './side-panel-small.component.html',
  styleUrls: ['./side-panel-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('sidePanel', [
      state('in', style({ transform: 'translateX(0)' })),
      transition(':enter', [style({ transform: 'translateX(360px)' }), animate('192ms')]),
      transition(':leave', [animate('192ms', style({ transform: 'translateX(360px)' }))])
    ])
  ]
})
export class SidePanelSmallComponent {
  @Input()
  isSidePanelOpened: boolean;

  @Output()
  public closePanel: EventEmitter<void> = new EventEmitter();

  @HostBinding('@sidePanel')
  public animationType = 'in';

  public onCloseClick(): void {
    this.closePanel.emit();
  }
}
